/* Homepage ingredient collage bubble — Hydrogen HomePage.tsx @ 94cc6d6 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function headerOffset() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--v4-header-h');
    var parsed = parseFloat(raw);
    return Number.isFinite(parsed) ? parsed : 72;
  }

  function initCollage() {
    var collage = document.querySelector('[data-bal-ingredient-collage]');
    var bubble = document.getElementById('v4-ingredient-bubble');
    if (!collage || !bubble) return;

    var active = null;
    var detailsCache = null;
    var scrollTimer = null;
    var onOutsideClick = null;

    function stickers() {
      return collage.querySelectorAll('[data-ingredient-slug]');
    }

    function ensureBubbleFullyVisible() {
      var card = bubble.querySelector('.v4-ingredient-bubble__card');
      if (!card) return;

      var rect = card.getBoundingClientRect();
      var pad = 20;
      var topLimit = headerOffset() + pad;
      var bottomLimit = window.innerHeight - pad;
      var delta = 0;

      if (rect.top < topLimit) {
        delta = rect.top - topLimit;
      } else if (rect.bottom > bottomLimit) {
        delta = rect.bottom - bottomLimit;
      }

      if (delta !== 0) {
        window.scrollBy({
          top: delta,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        });
      }
    }

    function scrollBubbleIntoView() {
      if (scrollTimer) window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        requestAnimationFrame(function () {
          var card = bubble.querySelector('.v4-ingredient-bubble__card');
          if (card) {
            card.scrollIntoView({
              behavior: prefersReducedMotion() ? 'auto' : 'smooth',
              block: 'center',
              inline: 'nearest',
            });
          } else {
            bubble.scrollIntoView({
              behavior: prefersReducedMotion() ? 'auto' : 'smooth',
              block: 'center',
              inline: 'nearest',
            });
          }
          window.setTimeout(ensureBubbleFullyVisible, prefersReducedMotion() ? 0 : 320);
        });
      }, 200);
    }

    function bindOutsideClose() {
      unbindOutsideClose();
      onOutsideClick = function (event) {
        if (!active) return;
        var target = event.target;
        if (!target || !(target instanceof Element)) return;
        if (bubble.contains(target)) return;
        if (target.closest('.v4-sticker__trigger')) return;
        setActive(null);
      };
      document.addEventListener('mousedown', onOutsideClick);
    }

    function unbindOutsideClose() {
      if (!onOutsideClick) return;
      document.removeEventListener('mousedown', onOutsideClick);
      onOutsideClick = null;
    }

    function setActive(slug) {
      active = slug;

      stickers().forEach(function (el) {
        var on = el.getAttribute('data-ingredient-slug') === slug;
        if (on) {
          el.setAttribute('data-active', 'true');
        } else {
          el.removeAttribute('data-active');
        }
        var btn = el.querySelector('.v4-sticker__trigger');
        if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      });

      if (slug) {
        collage.setAttribute('data-bubble-open', 'true');
        collage.setAttribute('data-engaged', 'true');
        bubble.setAttribute('data-open', 'true');
        bubble.setAttribute('aria-hidden', 'false');
        renderBubble(slug);
        scrollBubbleIntoView();
        bindOutsideClose();
        return;
      }

      collage.removeAttribute('data-bubble-open');
      bubble.removeAttribute('data-open');
      bubble.setAttribute('aria-hidden', 'true');
      bubble.innerHTML = '';
      unbindOutsideClose();
    }

    function closeBubble() {
      setActive(null);
    }

    function renderBubble(slug) {
      if (!detailsCache) return;
      var detail = detailsCache.details && detailsCache.details[slug];
      if (!detail) return;

      var activeEl = collage.querySelector('[data-ingredient-slug="' + slug + '"]');
      var imgEl = activeEl && activeEl.querySelector('.v4-sticker__plate img');
      var imgSrc = (imgEl && imgEl.getAttribute('src')) || '';
      var latinEl = activeEl && activeEl.querySelector('.v4-sticker__latin');
      var latin = latinEl ? latinEl.textContent.trim() : '';

      var body = (detail.paragraphs || [])
        .map(function (p) {
          return '<p>' + p + '</p>';
        })
        .join('');

      var citations = (detail.citations || [])
        .map(function (c) {
          return (
            '<li><a href="' +
            c.url +
            '" target="_blank" rel="noopener noreferrer" aria-label="See study, PubMed ID ' +
            c.pmid +
            ', opens in new tab">See study <span aria-hidden="true">\u2197</span><span class="v4-ingredient-bubble__pmid">PMID ' +
            c.pmid +
            '</span></a></li>'
          );
        })
        .join('');

      bubble.innerHTML =
        '<article class="v4-ingredient-bubble__card v4-ingredient-bubble__card--' +
        detail.group +
        '" role="region" aria-labelledby="v4-ingredient-bubble-name">' +
        '<button type="button" class="v4-ingredient-bubble__close" aria-label="Close ingredient detail">' +
        '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">' +
        '<line x1="2" y1="2" x2="12" y2="12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
        '<line x1="12" y1="2" x2="2" y2="12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
        '</svg></button>' +
        (imgSrc
          ? '<span class="v4-ingredient-bubble__plate" aria-hidden="true"><img src="' +
            imgSrc +
            '" alt="" loading="lazy" width="200" height="200"></span>'
          : '') +
        '<div class="v4-ingredient-bubble__content">' +
        '<p class="v4-ingredient-bubble__group-label"><span aria-hidden="true">\u25CF</span> ' +
        detail.groupLabel +
        (detail.unique ? ' <span class="v4-ingredient-bubble__badge">Unique to BC</span>' : '') +
        '</p>' +
        '<h3 id="v4-ingredient-bubble-name" class="v4-ingredient-bubble__name">' +
        detail.fullName +
        (latin ? ' <em class="v4-ingredient-bubble__latin">' + latin + '</em>' : '') +
        '</h3>' +
        '<p class="v4-ingredient-bubble__dose">' +
        detail.dose +
        '</p>' +
        '<p class="v4-ingredient-bubble__lead">' +
        detail.lead +
        '</p>' +
        '<div class="v4-ingredient-bubble__body">' +
        body +
        '</div>' +
        (citations ? '<ul class="v4-ingredient-bubble__citations">' + citations + '</ul>' : '') +
        '</div></article>';

      bubble.querySelector('.v4-ingredient-bubble__close').addEventListener('click', closeBubble);
    }

    collage.addEventListener('click', function (event) {
      var btn = event.target.closest('.v4-sticker__trigger');
      if (!btn || !collage.contains(btn)) return;
      var article = btn.closest('[data-ingredient-slug]');
      if (!article) return;
      var slug = article.getAttribute('data-ingredient-slug');
      if (!slug) return;
      setActive(active === slug ? null : slug);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && active) closeBubble();
    });

    var jsonUrl = collage.getAttribute('data-ingredient-json');
    if (!jsonUrl) return;

    fetch(jsonUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('ingredient JSON ' + res.status);
        return res.json();
      })
      .then(function (data) {
        detailsCache = data;
        if (active) renderBubble(active);
      })
      .catch(function () {
        /* Bubble shell still opens; content stays empty if JSON fails. */
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollage);
  } else {
    initCollage();
  }
})();
